import axios from 'axios';
import Common from '../../Common';
import Auth from '../../Common/Auth';
import ReactGA from 'react-ga';

class PlayBehaviorService {
    constructor(props) {
        let auth = new Auth(null);
        let token = auth.getLocalToken();

        this.headers = {}
        if(token !== null) {
            this.headers = {'Authorization': "Token " + token};
        }

        this.httpClient = axios.create();
        this.httpClient.defaults.timeout = 2000;
    }

    getCurrentPlayBehaviorId = async () => {
        return this.httpClient.get(Common.getProbEndpoint() + "current-play-behavior/", {headers: this.headers})
        .then((response) => {
            return response.data
        })
        .catch((error) => {
            this.handleError(error)
        });
    }

    getPlayBehaviorById = async (id) => {
        return this.httpClient.get(Common.getProbEndpoint() + "play-behavior/" + id, {headers: this.headers})
        .then((response) => {
            return response.data
        })
        .catch((error) => {
            this.handleError(error)
        });
    }

    getUserPlayBehaviors = async () => {
        return this.httpClient.get(Common.getProbEndpoint() + "play-behavior/", {headers: this.headers})
        .then((response) => {
            return response.data
        })
        .catch((error) => {
            this.handleError(error)
        });
    }

    getCurrentPlayBehavior = async () => {
        let currentPlayBehaviorIdObj = await this.getCurrentPlayBehaviorId();

        let currentPlayBehaviorObj = await this.getPlayBehaviorById(currentPlayBehaviorIdObj.currentBehavior.id);

        return currentPlayBehaviorObj;
    }

    handleError = (error) => {
        if(error.response !== undefined) {
            ReactGA.event({
                category: 'Error',
                action: 'Get Current Play Behavior Error',
                label: error.response.data.message,
            });

            window.alert("Cannot get current hand range... Message: " + error.response.data.message);
        } else {
            ReactGA.event({
                category: 'Error',
                action: 'Get Current Play Behavior Error',
                label: 'Unknown',
            });
            window.alert("Cannot get current hand range... Try again later.");
        }

        throw new Error('Cannot get play behavior')
    }
}

export default PlayBehaviorService;